import { StyleSheet, Platform, I18nManager } from 'react-native';

import { Fonts } from '../../Themes';

const circleStyle = {
  borderRadius: 9,
  height: 18,
  marginLeft: -20,
  width: 18,
};

const hederTextStyle = {
  fontSize: 18,
  marginLeft: I18nManager.isRTL ? 5 : 15,
  marginRight: I18nManager.isRTL ? 15 : 5,
  // color: Colors.grey40,
  lineHeight: 18,
  letterSpacing: 0,
  fontFamily: Fonts.type.VFFont,
};

export default StyleSheet.create({
  header: {
    flex: 1,
    flexDirection: 'row',
  },
  headerTextContainerStyle: {
    flex: 1,
  },
  inActiveHeaderTextStyle: {
    ...hederTextStyle,
  },
  activeHeaderTextStyle: {
    ...hederTextStyle,
    ...Fonts.type.bold,
    paddingTop: Platform.OS === 'ios' ? 2 : null,
  },
  newOrSkippedCircleStyle: theme => ({
    ...circleStyle,
    backgroundColor: theme.colors.nonCompletedCircle,
  }),
  activeCircleStyle: theme => ({
    backgroundColor: theme.colors.backgroundColor,
    borderColor: theme.colors.activeStep,
    borderRadius: 20,
    borderWidth: 1,
    marginLeft: -22,
    padding: 2,
  }),
  activeInnerCircleStyle: theme => ({
    ...circleStyle,
    backgroundColor: theme.colors.activeStep,

    marginLeft: 0,
  }),
  completedCircleStyle: theme => ({
    ...circleStyle,
    backgroundColor: theme.colors.activeStep,
  }),
});
